class Messenger {
  constructor() {
    this.subscribers = []
  }

  subscribe = (name, channel, callback) => {
    this.subscribers.push({
      name,
      channel,
      callback,
    })
  }

  unsubscribe = name => {
    this.subscribers = this.subscribers.filter(subscriber => subscriber.name !== name)
  }

  emit = (channel, event) => {
    this.subscribers.forEach(subscriber => {
      if (
        (Array.isArray(subscriber.channel) && subscriber.channel.includes(channel)) ||
        subscriber.channel === channel
      ) {
        subscriber.callback(event, channel)
      }
    })
  }
}

const messenger = new Messenger()
export default messenger
